import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { axiosNewInstance } from "../../config/Api";
import { connect, useSelector } from "react-redux";
import LangData from "../common/LangData";

const PolicyList = ({ lang }) => {
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);
  const history = useHistory();
  const token = localStorage.getItem("authToken");
  const user = useSelector((state) => state?.user);
  console.log("jhsdbfjsdfhsdf", user.loginuser)

  useEffect(() => {
    if (token) {
      fetchDashboardData();
    } else {
      history.push("/login");
    }
  }, []);

  const fetchDashboardData = async (page = 1) => {
    const FETCH_DASHBOARD_URL = "/api-app/get-policy-list";
    setLoading(true);
    try {
      const response = await axiosNewInstance.post(
        FETCH_DASHBOARD_URL,
        { page },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log("Fetched user dashboard data:", response.data.data.policies);
      setDashboardData(response?.data?.data?.policies || []);
    } catch (error) {
      console.error("Error fetching user dashboard:", error?.response || error);
      // if (error.response?.data?.status === 0) {
      //   localStorage.removeItem("authToken");
      //   history.push("/login");
      // }
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (policyId) => {
    history.push({
      pathname: "/policy-buy",
      state: { policyId: policyId, isEditing: true },
    });
  };
  const handleView = (policyId) => {
    history.push(`/policy-view/${policyId}`);
  };
  
  // const handleChange = () => {};

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     width: 300,
  //   }),
  // };

  return (
    <div className="container">
      <div>
        <div className="row g-0">
          <div className="col-md-12 pr-2 mt-4">
            <div className="card p-3 shadow-sm">
            <h5 className="font-weight-bold fs-4 my-3">
              <LangData keyname="label_policy_list" />
              </h5>
              <div className="table-responsive">
                <table className="table text-left">
                <thead>
                    <tr>
                      {/* <th scope="col" className="text-left">SL</th>
                      <th scope="col" className="text-left">Policy ID</th>
                      <th scope="col" className="text-left">Name</th>
                      <th scope="col" className="text-left">Phone</th>
                      <th scope="col" className="text-left">Product Name</th>
                      <th scope="col" className="text-left">Status</th>
                      <th scope="col" className="text-left">Action</th> */}
                       <th scope="col"><LangData keyname="label_serial" /></th>
                       <th scope="col"><LangData keyname="label_name" /></th>
                       <th scope="col"><LangData keyname="label_policy_id" /></th>
                       <th scope="col"><LangData keyname="label_ref_id" /></th>
                       <th scope="col"><LangData keyname="label_mobile" /></th>
                       <th scope="col"><LangData keyname="label_product_name" /></th>
                       <th scope="col"><LangData keyname="label_status" /></th>
                      <th scope="col"><LangData keyname="label_action" /></th>
                    </tr>
                  </thead>
                  <tbody>
                    {dashboardData && dashboardData.length > 0 ? (
                      dashboardData.map((item, index) => (
                        <tr key={item?.id}>
                          <td>{index + 1}</td>
                          <td>
                            {item?.customer?.first_name || ""}{" "}
                            {item?.customer?.last_name || ""}
                          </td>
                          <td>{item?.sap_policy_id}</td>
                          <td>{item?.ref_unique_id}</td>
                          <td>{item?.customer?.mobile || "N/A"}</td>
                          <td>{item?.policy?.name || "N/A"}</td>
                          <td
                            className={
                              item?.status === 3
                                ? "text-primary"
                                : item?.status === 4
                                ? "text-success"
                                : item?.status === 1 || item?.status === 2
                                ? "text-warning"
                                : item?.status === 6
                                ? "text-danger"
                                : "text-secondary"
                            }
                          >
                            {item?.status === 0
                              ? "Draft"
                              : item?.status === 1
                              ? "Submitted"
                              : item?.status === 2
                              ? "Submitted & Uploaded to LIC"
                              : item?.status === 3
                              ? "Active"
                              : item?.status === 4
                              ? "Mature"
                              : item?.status === 6
                              ? "Failed To Push"
                              : "Unknown"}
                          </td>
                          {/* <td>
                            <i className="far fa-eye mt-1"></i>
                          </td> */}
                          <td>
                            {/* <button
                              className="btn btn-info btn-sm"
                              onClick={() => handleEdit(item.id)}
                              disabled={item?.status === 0 ? false : true}
                            >
                              <i className="fas fa-edit"></i>
                            </button> */}
                            <button
                              className="btn btn-info btn-sm"
                              onClick={() => handleEdit(item.id)}
                              disabled={item?.status !== 0 || user?.loginuser?.id === 1}
                            >
                              <i className="fas fa-edit"></i>
                            </button>

                            <button
                              className="btn btn-primary btn-sm ms-1"
                              onClick={() => handleView(item?.id)}
                            >
                              <i className="fas fa-eye"></i>
                            </button>

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center text-muted">
                          No Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lang: state.lang,
});

export default connect(mapStateToProps)(PolicyList);
